// puf_noktalari DB'de birden çok biçimde yazılmış (ölçüm 2026-10-13, v_sorular_birlesik):
// [{baslik, aciklama}] 7427 · [{konu, metin}] 6778 (+7 `formul` alanlı) · [string] 3321 ·
// tek metin 76 · [{baslik, icerik}] 15. Görüntüleyici hepsini {baslik, aciklama, formul}e indirger.
export function pufListesi(v) {
  let x = v;
  if (typeof x === 'string') {
    try { x = JSON.parse(x); } catch { return x.trim() ? [{ aciklama: x }] : []; }
    if (typeof x === 'string') return x.trim() ? [{ aciklama: x }] : [];
  }
  if (!Array.isArray(x)) return [];
  return x
    .map((p) => {
      if (typeof p === 'string') return { aciklama: p };
      if (!p || typeof p !== 'object') return null;
      const aciklama = p.aciklama ?? p.metin ?? p.icerik;
      // formul çoğu kayıtta metnin içinde zaten geçiyor (#17211) — ikinci kez basılmaz.
      const sade = (s) => String(s ?? '').replace(/[\s$]/g, '');
      const formul = p.formul && !sade(aciklama).includes(sade(p.formul)) ? p.formul : undefined;
      return { baslik: p.baslik ?? p.konu, aciklama, formul };
    })
    .filter((p) => p && (p.baslik || p.aciklama || p.formul));
}
